import { render } from "./company-contacts.vue?vue&type=template&id=726e143a&ts=true"
import script from "./company-contacts.vue?vue&type=script&lang=ts"
export * from "./company-contacts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__